<app-page-header
  title="Impressum"
  subtitle="Rechtliche Informationen über NicLen GmbH"
  icon="info"
  variant="gradient">
</app-page-header>

<div class="nlc-container nlc-slide-up">
  <section class="nlc-card impressum-section">
    <div class="impressum-section-header">
      <mat-icon class="section-icon">business</mat-icon>
      <h2 class="nlc-heading-3">Unternehmen</h2>
    </div>
    <div class="impressum-company-block">
      <p class="company-name"><strong>NicLen GmbH</strong></p>
      <p class="nlc-body-secondary company-sub">
        (NicLen Gesellschaft für Elektronik, Handel und Vermietung mbH,
        NicLen B.V., NicLen SARL, NicLen Ltd., NicLen CH AG, NicLen Holding GmbH)
      </p>
      <p class="nlc-body">Geschäftsführer: Nico Valasik &amp; Jörg Stöppler</p>
      <div class="info-row">
        <mat-icon class="info-icon">location_on</mat-icon>
        <span class="nlc-body">Steinbrinkstraße 61, 44319 Dortmund, Deutschland</span>
      </div>
    </div>
  </section>
  <section class="nlc-card impressum-section">
    <div class="impressum-section-header">
      <mat-icon class="section-icon">contact_mail</mat-icon>
      <h2 class="nlc-heading-3">Kontakt</h2>
    </div>
    <div class="impressum-contact-block">
      <div class="info-row">
        <mat-icon class="info-icon">email</mat-icon>
        <span class="nlc-body">
          <strong>Email:</strong>
          <a href="mailto:dispo&#64;niclen.de" class="nlc-link">dispo&#64;niclen.de</a>
        </span>
      </div>
      <div class="info-row">
        <mat-icon class="info-icon">public</mat-icon>
        <span class="nlc-body">
          <strong>Web:</strong>
          <a href="https://www.niclen.de" target="_blank" class="nlc-link">www.niclen.de</a>
        </span>
      </div>
      <div class="info-row">
        <mat-icon class="info-icon">phone</mat-icon>
        <span class="nlc-body">
          <strong>Phone:</strong>
          <a href="tel:+49231999610" class="nlc-link">+49 231 / 999 61-0</a>
        </span>
      </div>
      <div class="info-row">
        <mat-icon class="info-icon">print</mat-icon>
        <span class="nlc-body"><strong>Fax:</strong> +49 231 / 999 61-38</span>
      </div>
    </div>
  </section>

  <section class="nlc-card impressum-section">
    <div class="impressum-section-header">
      <mat-icon class="section-icon">gavel</mat-icon>
      <h2 class="nlc-heading-3">Rechtliches</h2>
    </div>
    <div class="impressum-legal-block">
      <p class="nlc-body"><strong>UstID:</strong> DE155852786</p>
      <p class="nlc-body"><strong>HRB:</strong> 24618 Amtsgericht Dortmund</p>
    </div>
  </section>

  <section class="nlc-card impressum-section">
    <div class="impressum-section-header">
      <mat-icon class="section-icon">shield</mat-icon>
      <h2 class="nlc-heading-3">Verantwortung</h2>
    </div>
    <div>
      <p class="nlc-body"><strong>Journalistisch-redaktionell gestaltete Angebote</strong></p>
      <p class="nlc-body-secondary">
        Inhaltlich verantwortlich nach § 55 Abs. 2 RStV: Nico Valasik &amp; Jörg
        Stöppler (Geschäftsführer – Kontakt:
        <a href="mailto:marketing&#64;niclen.de" class="nlc-link">marketing&#64;niclen.de</a>).
      </p>
    </div>
  </section>
  <section class="nlc-card impressum-section">
    <div class="impressum-section-header">
      <mat-icon class="section-icon">share</mat-icon>
      <h2 class="nlc-heading-3">Social Media</h2>
    </div>
    <ul class="impressum-social-list">
      <li class="social-item">
        <mat-icon class="social-icon">facebook</mat-icon>
        <a href="https://www.facebook.com/niclen.dryhire/" target="_blank" class="nlc-link">Facebook</a>
      </li>
      <li class="social-item">
        <mat-icon class="social-icon">photo_camera</mat-icon>
        <a href="https://www.instagram.com/niclen_dryhire/" target="_blank" class="nlc-link">Instagram</a>
      </li>
      <li class="social-item">
        <mat-icon class="social-icon">work</mat-icon>
        <a href="https://de.linkedin.com/company/niclen-family" target="_blank" class="nlc-link">LinkedIn</a>
      </li>
      <li class="social-item">
        <mat-icon class="social-icon">play_circle</mat-icon>
        <a href="https://www.youtube.com/user/beamover" target="_blank" class="nlc-link">YouTube</a>
      </li>
      <li class="social-item">
        <mat-icon class="social-icon">music_note</mat-icon>
        <a href="https://www.tiktok.com/&#64;niclen_family" target="_blank" class="nlc-link">TikTok</a>
      </li>
    </ul>
  </section>

  <section class="nlc-card impressum-section">
    <div class="impressum-section-header">
      <mat-icon class="section-icon">link</mat-icon>
      <h2 class="nlc-heading-3">Links</h2>
    </div>
    <div>
      <p class="nlc-body-secondary">
        Auf unseren Internetseiten finden Sie auch Links zu anderen Seiten im
        Internet. Wir möchten Sie darauf hinweisen, dass wir keinen Einfluss auf
        die Gestaltung und den Inhalt der Seiten haben, auf die verlinkt wird.
        Wir können daher auch keine Gewähr für die Aktualität, Korrektheit,
        Vollständigkeit oder Qualität der dort bereitgestellten Informationen
        übernehmen. Vor diesem Hintergrund distanzieren wir uns hiermit von
        allen Inhalten dieser Seiten. Diese Erklärung gilt für alle auf unseren
        Internetseiten enthaltenen Links zu externen Seiten und deren Inhalte.
      </p>
    </div>
  </section>

  <section class="nlc-card impressum-section">
    <div class="impressum-section-header">
      <mat-icon class="section-icon">copyright</mat-icon>
      <h2 class="nlc-heading-3">Copyright</h2>
    </div>
    <div>
      <p class="nlc-body">
        © NicLen Gesellschaft für Elektronik, Handel und Vermietung mbH, 2025
      </p>
    </div>
  </section>
</div>
